@let copy = pageCopy();
@let canManageTellentValue = canManageTellent();

<div class="text" margin-right-large>
  <div class="heading">
    <rt-heading>
      {{ 'tlc.members.edit_member.permission_access_tab.permission_level.heading' | translate }}
    </rt-heading>
    <rt-badge [color]="copy.badge.color" [text]="copy.badge.text" margin-left-small-xx />
  </div>
  <div class="description">
    {{ copy.description }}
  </div>
</div>
<div
  class="actions"
  [rtTooltip]="'tlc.members.edit_member.permission_access_tab.edit_button_tooltip' | translate"
  [rtTooltipPosition]="'below'"
  [rtTooltipEnabled]="!canManageTellentValue"
>
  <rt-button
    [variant]="copy.cta.variant"
    [disabled]="!canManageTellentValue"
    (click)="actionClicked.emit()"
  >
    <rt-icon [name]="copy.cta.icon" />
    <span>{{ copy.cta.text }}</span>
  </rt-button>
</div>
